import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const tags = [
  "Development Financing",
  "Bridge Loans",
  "Construction Loans",
  "Acquisition Financing",
  "Refinancing",
  "Structured Capital",
];

export default function FinancingStrip() {
  const navigate = useNavigate();

  return (
    <section className="relative border-t border-[#D4AF37]/10 bg-[#080808]" data-testid="financing-strip">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 lg:py-24 grid lg:grid-cols-[1.5fr_1fr] gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
        >
          <p className="text-[11px] tracking-[0.45em] uppercase text-[#D4AF37] mb-6" data-testid="financing-strip-overline">
            Commercial Real Estate Financing
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light leading-[1.08] tracking-tight text-[#F5F5F5]" data-testid="financing-strip-headline">
            Capital for Acquisition,
            <br />
            Development &amp; <span className="italic text-[#D4AF37]">Construction</span>
          </h2>
          <p className="mt-6 max-w-lg text-base font-light leading-relaxed tracking-wide text-[#A3A3A3]">
            Commercial financing solutions for developers, investors and property owners.
          </p>
          <div className="mt-8 flex flex-wrap gap-x-5 gap-y-2.5" data-testid="financing-strip-tags">
            {tags.map((t) => (
              <span key={t} className="flex items-center gap-2.5 text-[10px] tracking-[0.24em] uppercase text-[#A3A3A3]">
                <span className="w-1 h-1 bg-[#D4AF37] rotate-45" aria-hidden="true" />
                {t}
              </span>
            ))}
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.15 }}
          className="flex flex-col gap-4 lg:items-end"
        >
          <button
            onClick={() => navigate("/financing")}
            data-testid="explore-financing-button"
            className="group w-full lg:w-auto flex items-center justify-center gap-3 bg-[#D4AF37] text-black px-10 py-4 text-[11px] tracking-[0.3em] uppercase font-medium hover:bg-[#F3E5AB] transition-colors duration-300"
          >
            Explore Financing
            <ArrowRight size={14} strokeWidth={1.5} className="transition-transform duration-300 group-hover:translate-x-1" />
          </button>
          <button
            onClick={() => navigate("/financing", { state: { scrollTo: "#funding-form" } })}
            data-testid="submit-project-strip-button"
            className="w-full lg:w-auto border border-[#D4AF37]/40 text-[#D4AF37] px-10 py-4 text-[11px] tracking-[0.3em] uppercase hover:bg-[#D4AF37] hover:text-black transition-colors duration-300"
          >
            Submit a Project
          </button>
          <p className="max-w-xs lg:text-right text-[9px] font-light leading-relaxed tracking-[0.12em] uppercase text-[#A3A3A3]/60" data-testid="financing-strip-disclosure">
            Capital arranged through third-party lenders and capital partners — subject to underwriting, eligibility and lender approval. Veritas is not a direct lender.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
